export const  GET_NOTES_REQUEST='notesReducer/GET_NOTES_REQUEST';
export const  GET_NOTES_SUCCESS='notesReducer/GET_NOTES_SUCCESS';
export const  GET_NOTES_FAILED='notesReducer/GET_NOTES_FAILED';